import { IonImg, IonPage } from '@ionic/react'
import styled from 'styled-components'

export const Page = styled(IonPage)`
	position: relative;
	width: 100%;
	height: 100%;
	background: conic-gradient(
		from 179.88deg at 49.87% 37.41%,
		#c3d6f7 0deg,
		#bacff3 50.4deg,
		#81a1dc 360deg
	);
	display: flex;
	align-items: center;
	justify-content: center;
`

export const LogoText = styled(IonImg)`
	position: absolute;
	width: 165px;
	height: 60px;
	top: 25%;
	left: 50%;
	transform: translate3d(-50%, 0, 0);
	display: block;
`
